<div class="container-fluid p-4">
	<app-report-generator [selectedReport]="enums.STAMP_HQ_SUMMARY" [selectedCompanyGroup]="companyGroup"></app-report-generator>

	<div class="p-2 mt-2">
		<h2>STAMP HQ Summary ({{ startDate | date: 'dd-MM-yyyy' }} to {{ endDate | date: 'dd-MM-yyyy' }})</h2>
		<div class="d-flex gap-3">
			<mat-form-field subscriptSizing="dynamic">
				<mat-label>Search</mat-label>
				<input matInput type="text" placeholder="Search" [(ngModel)]="searchText" (keyup)="applyFilter($event)" />
			</mat-form-field>
		</div>
	</div>
	<table mat-table [dataSource]="dataSource" matSort>
		<ng-container matColumnDef="CompanyCode">
			<th mat-header-cell *matHeaderCellDef mat-sort-header>Company Code</th>
			<td mat-cell *matCellDef="let report">{{ report.CompanyCode }}</td>
		</ng-container>

		<ng-container matColumnDef="TotalIn">
			<th mat-header-cell *matHeaderCellDef mat-sort-header>Total In</th>
			<td mat-cell *matCellDef="let report">{{ report.TotalIn }}</td>
		</ng-container>

		<ng-container matColumnDef="TotalOut">
			<th mat-header-cell *matHeaderCellDef mat-sort-header>Total Out</th>
			<td mat-cell *matCellDef="let report">{{ report.TotalOut }}</td>
		</ng-container>

		<ng-container matColumnDef="Total">
			<th mat-header-cell *matHeaderCellDef mat-sort-header>Total</th>
			<td mat-cell *matCellDef="let report">{{ report.Total }}</td>
		</ng-container>

		<tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
		<tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
	</table>
	<mat-paginator [pageSize]="50" [pageSizeOptions]="[50, 100, 200, 500]" showFirstLastButtons> </mat-paginator>
</div>
